module.exports = __webpack_public_path__ + "img/export.a12d0245.png";